<template>
  <el-container class="signature">
    <el-header class="header">
		<span>个性签名设置</span>
		<i class="el-icon-close" @click="closeSignature"></i>
	</el-header>
    <el-main class="main">
		<el-input class="signtextarea" type="textarea" :rows="3" placeholder="请输入其他原因" v-model="textarea" resize="none">
		</el-input>
		<div class="submit-btn" @click="submit">确定</div>
	</el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Signature',
  data(){
	return{
		textarea:'',
	}
  },
  props:{
  	User_code:String,
  },
  methods:{
	closeSignature(){
		this.$emit('closeSignature')
		console.log(this.textarea)
	},
	// 提交
	async submit(){
		var that = this
		var res = await that.$axios.post('/friends/editUserInfo', {
			User_code: that.User_code,
			param: that.textarea,
			type: 'signature'
		})
		if(res.data.done){
			that.$message.success('修改成功')
			this.$emit('editDisturb')
		}else{
			that.$message.error(res.data.msg);
		}
		that.closeSignature();
	},
  },
  created(){
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.signature{
		width: 660px;
		height: 440px;
	}
	.header{
		margin: 0;
		padding: 0 24px;
	}
	.main {
		margin: 0;
		padding: 24px;
	}
	
	.header {
		background-color: #354052;
		color: #fff;
		display: flex;
		box-sizing: border-box;
		justify-content: space-between;
		align-items: center;
		height: 40px;
		font-size: 14px;
	}
	
	.header i {
		font-size: 22px;
	}
	
	.main .left {
		width: 118px;
		display: inline-block;
		background-color: #e0e7f1;
		color: #333;
		height: 100%;
		float: left;
	}
	.main .right {
		width: calc(100% - 118px);
		display: inline-block;
		font-size: 14px;
		box-sizing: border-box;
		color: #888888;
		overflow: auto;
		box-sizing: border-box;
		float: left;
		height: 100%;
	}
	.submit-btn{
		width: 70px;
		height: 20px;
		border: 1px solid #333;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 24px;
	}
</style>
